import { render, staticRenderFns } from "./success-snackbar.vue?vue&type=template&id=71db7374&scoped=true&lang=pug"
import script from "./success-snackbar.vue?vue&type=script&lang=js"
export * from "./success-snackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71db7374",
  null
  
)

export default component.exports